import { render } from "./ManagerSidebar.vue?vue&type=template&id=10685d60"
import script from "./ManagerSidebar.vue?vue&type=script&lang=js"
export * from "./ManagerSidebar.vue?vue&type=script&lang=js"

import "./ManagerSidebar.vue?vue&type=style&index=0&id=10685d60&lang=css"

import exportComponent from "C:\\pythonproject0\\tkrforntend\\tkrforntend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__